import React, { useState, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useAuth } from '../../auth/AuthContext';
import "./LayoutContainer.scss";
// import Footer from "../Footer/Footer";
import Navibar from '../Navigator/component/NaviBar';
import Sidebar from '../Sidebar/Sidebar';

const LayoutContainer = () => {
  const [isExpanded, setIsExpanded] = useState(true);
  const { userIsAuthenticated, userLogout } = useAuth();
  const navigate = useNavigate();
  
  // 인증 체크: 로그인되지 않은 사용자를 /login으로 리다이렉트
  useEffect(() => {
    if (!userIsAuthenticated()) {
      userLogout();
      navigate('/login', { replace: true });
    }
  }, [userIsAuthenticated, userLogout, navigate]);
  
  // 팝업 창인지 확인
  const isPopupWindow = window.opener && window.opener !== window;

  const handleSidebarToggle = (expanded) => {
    setIsExpanded(expanded);
  };
  
  // 인증되지 않은 경우 아무것도 렌더링하지 않음
  if (!userIsAuthenticated()) {
    return null;
  }

  return (
    <div className="layout">
      {!isPopupWindow && (
        <Sidebar isExpanded={isExpanded} onToggle={handleSidebarToggle} />
      )}
      <div className={`main-content ${!isPopupWindow && isExpanded ? 'sidebar-expanded' : ''}`}>
        {!isPopupWindow && <Navibar />}
        <div className="wrapper_page">
          <div className="wrapper_page__item">
            <div className="content-area">
              <Outlet />
            </div>
            {/* <Footer /> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LayoutContainer;
